import React from 'react';

const AdminSubIndustriesStats = ({
  loading,
  totalSubIndustries,
  filteredCount,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
    <div className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-purple-100 dark:bg-purple-900/30 rounded-md flex items-center justify-center">
              <span className="text-purple-600 dark:text-purple-400 text-sm">
                🔗
              </span>
            </div>
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">
                Total Sub-Industries
              </dt>
              <dd className="text-lg font-medium text-gray-900 dark:text-white">
                {loading ? '...' : totalSubIndustries}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-emerald-100 dark:bg-emerald-900/30 rounded-md flex items-center justify-center">
              <span className="text-emerald-600 dark:text-emerald-400 text-sm">
                🏭
              </span>
            </div>
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">
                Filtered Results
              </dt>
              <dd className="text-lg font-medium text-gray-900 dark:text-white">
                {loading ? '...' : filteredCount}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AdminSubIndustriesStats;


